/* eslint-disable */
let customConfig = {};
customConfig.vidoeExt = ['mp4'];
customConfig.docExt = ['pdf'];
customConfig.trainingDoc = [
    {
        name: 'How to: Agent Portal quote flow - Bundle',
        path: '/qrp/training-videos/QRP-AgentPortal-Bundle.mp4',
        ext: 'mp4',
    },
    {
        name: 'How to: Agent Portal quote flow - Auto',
        path: '/qrp/training-videos/QRP-AgentPortal-Auto.mp4',
        ext: 'mp4',
    },
    {
        name: 'How to: Agent Portal quote flow - Home',
        path: '/qrp/training-videos/QRP-AgentPortal-Home.mp4',
        ext: 'mp4',
    },
    {
        name: 'How to: Agency Admin Dashboard',
        path: '/qrp/training-videos/Agent-Portal-Admin.mp4',
        ext: 'mp4',
    },
    {
        name: 'Troubleshoot: Resolving Errors in a quote flow',
        path: '/qrp/training-videos/Agent-Portal-Error-Handling.mp4',
        ext: 'mp4',
    },
    {
        name: 'How to: Non End-to-End Carrier Walkthrough',
        path: '/qrp/training-videos/Agent-Portal-Non-Integrated.mp4',
        ext: 'mp4',
    },
    {
        name: 'How to: Do Not Call and Force Bind Features',
        path: '/qrp/training-videos/How-To-Do-Not-Call-And-Force-Bind-Features.mp4',
        ext: 'mp4',
    }
]

export {customConfig};



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = null
// module chunks = 